import * as ImportedIcons from './lucideIcons';

export const LUCIDE_ICONS = {
  ...ImportedIcons,
} as const;

export type LucideIconName = keyof typeof LUCIDE_ICONS;
